/*
 * @Date: 2019-12-08 17:13:38
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 16:52:10
 * @FilePath: /rongxin.web/src/views/home/index.js
 */
// component
import Navbar from '../../../components/navbar/index.vue';
import ProductService from '../../home/product-service/index.vue';
import contactUs from '../../home/contact-us/index.vue';
import Service from './servece.js';
export default {
  name: 'home',
  components: {
    Navbar,
    ProductService,
    contactUs
  },
  data() {
    return {
      fromisActiveClass: 'home',
      partnerArr: []
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.getPartnerList();
  },
  methods: {
    getPartnerList() {
      Service.getPartnerList({limit: 'unlimit', status: 1, source: 'guanWang'}).then(data => {
        this.partnerArr = data.data && data.data.result;
      });
    },
    goHome() {
      this.$router.push({path: 'home'});
    },
    goDetailNews() {
      this.$router.push({path: 'enterpriseDetailNews'});
    }
  }
};
